import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";

const useFetchUsers = () => {
  const {
    data: users = [], // The list of users we get from Supabase (or cache), default to empty array
    isLoading: isLoadingUsers, // Loading state while fetching users
    error, // Any error that happens during fetching
    refetch, // Function to manually refresh the data (e.g. refresh button)
  } = useQuery({
    queryKey: ["users"], // Unique identifier for this query

    // This is the function that actually gets users from Supabase
    queryFn: async () => {
      try {
        const { data, error } = await supabase
          .from("users")
          .select("*")
          .order("joined_at", { ascending: false });

        // If Supabase returns an error, stop and show it
        if (error) {
          throw new Error(error.message);
        }

        // Return the users we got from Supabase
        return data || [];
      } catch (error) {
        // If something unexpected happens, show a simple message
        throw new Error(
          error instanceof Error ? error?.message : "Something went wrong while getting users",
        );
      }
    },

    // Consider data fresh for 4 minutes to reduce unnecessary refetches
    staleTime: 1000 * 60 * 4,
    // Automatically remove from cache after 8 minutes of inactivity
    gcTime: 1000 * 60 * 8,
  });

  return {
    users,
    isLoadingUsers,
    usersError: error?.message ?? null,
    refetch,
  };
};

export default useFetchUsers;
